import React, { createContext, useContext, useState } from 'react';

const TabsContext = createContext();

export const Tabs = ({ value, onChange, children }) => {
  const [activeTab, setActiveTab] = useState(value || 0);

  const handleChange = (index) => {
    setActiveTab(index);
    onChange?.(index);
  };

  let panelIndex = -1;
  const childrenWithIndex = React.Children.map(children, (child) => {
    if (child?.type === TabPanel) {
      panelIndex++;
      return React.cloneElement(child, { index: panelIndex });
    }
    return child;
  });

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleChange }}>
      <div className="space-y-4">
        {childrenWithIndex}
      </div>
    </TabsContext.Provider>
  );
};

export const TabList = ({ children }) => {
  return (
    <div className="flex space-x-1 border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, { index })
      )}
    </div>
  );
};

export const Tab = ({ children, index }) => {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === index;

  return (
    <button
      onClick={() => setActiveTab(index)}
      className={`px-4 py-2 font-medium text-sm whitespace-nowrap border-b-2 transition-colors ${
        isActive
          ? 'text-primary-600 border-primary-600'
          : 'text-gray-600 dark:text-gray-400 border-transparent hover:text-gray-900 dark:hover:text-gray-200'
      }`}
    >
      {children}
    </button>
  );
};

export const TabPanel = ({ children, index }) => {
  const { activeTab } = useContext(TabsContext);
  
  if (activeTab !== index) return null;
  
  return (
    <div className="animate-fade-in">
      {children}
    </div>
  );
};